import React, { HTMLProps, useCallback, useState } from 'react';
import { useSafeContext, createNamedContext } from '@clover-util/react-context';
import { PromptModal } from 'components/PromptModal';

export type PromptState = {
  promptVisible: boolean;
  openPrompt: () => void;
  closePrompt: () => void;
  hydratePromptModal: (props: PromptProviderProps) => void;
}

export type PromptProviderProps = HTMLProps<HTMLElement> & {
  className?: string;
  primaryButtonContent?: string;
  secondaryButtonContent?: string;
  iconName?: string;
  title?: string;
  subtitle?: string;
  primaryOnClick?: () => void;
  secondaryOnClick?: () => void;
  onClose?: () => void;
};

export const PromptContext = createNamedContext<PromptState>('PromptContext');

export const usePrompt = () => useSafeContext(usePrompt, PromptContext);

export const PromptProvider: React.FC = ({ children }) => {
  const [promptVisible, setPrompModalVisible] = useState(false);
  const openPrompt = useCallback(() => setPrompModalVisible(true), []);
  const closePrompt = useCallback(() => setPrompModalVisible(false), []);
  const [modalProps, setModalProps] = useState<PromptProviderProps>();

  const hydratePromptModal = useCallback((props: PromptProviderProps) => {
    setModalProps(props);
    openPrompt();
  }, [setModalProps, openPrompt]);

  const value = {
    promptVisible,
    openPrompt,
    closePrompt,
    hydratePromptModal
  };

  return (
    <PromptContext.Provider value={value}>
      <PromptModal {...modalProps} isOpen={promptVisible} secondaryOnClick={modalProps?.secondaryOnClick || closePrompt} onClose={closePrompt}></PromptModal>
      {children}
    </PromptContext.Provider>
  );
};
